// for BG store 63
export const DELIVERY_LINE_ITEM = {
  class: '1',
  subclass: '1',
  division: '98',
  departmentCode: '995',
};

export const GIFT_WRAP_LINE_ITEM = {
  class: '1',
  subclass: '1',
  division: '98',
  departmentCode: '903',
};

export const LINE_ITEM_TYPE = {
  PRODUCT: 'PRODUCT',
  GIFT_WRAP: 'GIFT_WRAP',
  DELIVERY: 'DELIVERY',
  PROMOTION: 'PROMOTION',
};
